




























































import {focusNextElement, getPath, isObject, PlainObject} from '@labor-digital/helferlein';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {PreparedListItem} from '../../../Utils/Mixin/ListItemMixin';
import templateFactory from '../../../Utils/templateFactory';
import VuDropdownItem from '../Dropdown/Item/VuDropdownItem.vue';
import VuDropdown from '../Dropdown/VuDropdown.vue';
import VuFormInput from '../FormInput/VuFormInput.vue';
import VuFormTypeaheadAbstract from './VuFormTypeaheadAbstract.vue';

@Component({
    components: {VuDropdown, VuDropdownItem, VuFormInput}
})
export default class VuFormTypeaheadTemplate extends Vue
{
    protected ignoreFocus: boolean = false;

    @Prop({type: Object, default: () => ({})})
    readonly inputComponentProps: PlainObject;

    @Prop({type: Object, default: () => ({})})
    readonly dropdownComponentProps: PlainObject;

    @Prop({type: Object, default: () => ({})})
    readonly dropdownItemComponentProps: PlainObject;

    get p(): VuFormTypeaheadAbstract
    {
        return this.$parent as any;
    }

    get inputComponent()
    {
        return templateFactory(this.p.inputComponent, this.p);
    }

    protected onFocus()
    {
        if (!this.ignoreFocus) {
            this.p.openDropdown();
        }
    }

    protected getInputRef(): HTMLElement | null
    {
        return getPath(this.$refs, 'input.$refs.template.$refs.input') as any;
    }

    protected onKeyUp(e: KeyboardEvent)
    {
        if (e.code === 'ArrowDown') {
            if (!this.p.isDropdownOpen) {
                this.p.openDropdown();
            } else {
                const el = this.getInputRef();
                const active = (document.activeElement ?? document.body as any) as HTMLElement;
                // @todo compare with getInputRef() if we dropped the old input fields
                if (active && active.tagName === 'INPUT') {
                    const it = focusNextElement(document.activeElement ?? document.body as any);
                }
            }
        }
    }

    protected setValue(item: PreparedListItem): void
    {
        const el = this.getInputRef();
        if (isObject(el)) {
            this.ignoreFocus = true;
            el.focus();
            setTimeout(() => this.ignoreFocus, 100);
        }
        this.p.$emit('input', item.label);
        this.p.$emit('select', item);
        this.p.closeDropdown();
    }

    protected onDropdownKeyUp(e: KeyboardEvent, item: PreparedListItem)
    {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
            this.setValue(item);
        }
    }
}
